
import Vue from "vue";

export default Vue.extend({
  name: "VOrderSyncMsg",
  props: {
    list: Array
  },
  data() {
    return {
      visible: false,
      columns: [
        {
          title: "信息内容",
          dataIndex: "msg"
        },
        {
          title: "发生时间",
          dataIndex: "time",
          scopedSlots: { customRender: "time" }
        }
      ]
    };
  }
});
